import * as React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";


const Search = (props) => {
  return (
    <Paper
      component="form"
      sx={{ p: "2px 4px",marginLeft:"0rem", display: "flex", alignItems: "center", width: 400 }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Search here..."
        inputProps={{ "aria-label":"Search here..."}}
        defaultValue={props.SearchString}
        onChange={(e)=>{
            e.preventDefault()
            props.onchange(e.target.value)
        }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search" onClick={props.hitEnter}>
        <SearchIcon />
      </IconButton>   
    </Paper>
  );
};
export default Search;
